import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState, useRef } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useTranslation } from "@i18n";
import useIsMobile from "@hooks/useIsMobile";
import stl from "@/pages/checkout/finance-checkout/FreeFinanceFormPage.module.css";
import TamaraInfoComponent from "@/pages/checkout/tamara/componsnt/TamaraInfoComponent";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useHelpers from "@hooks/useHelpers";
import OtpVerification from "@/_MiniApps/auth/ui/OTP/OtpVerification";
import SharedPopUp from "@componentsShared/SharedPopUp/SharedPopUp";
import { handleHasAccountEvent } from "@/utils/common";
import { useLang } from "@/common/Contexts/LanguageContext";
import { twMerge } from "tailwind-merge";
import useWebviewInputFieldFocusBehavior from "@hooks/useWebviewInputFieldFocusBehavior";
import useIsWebView from "@hooks/useIsWebview";
import useWebview from "@hooks/useWebview";
import PaymentInfoV2 from "@/pages/checkout/components/PaymentInfo/PaymentInfoV2";
import { OrderPaidError, PostReservedError } from "@/apis/orders/orders";
import useBoolean from "@hooks/useBoolean";
import MobileCarInfoV2 from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/MobileCarInfoV2";
import { useTamaraFinance } from "@/common/Contexts/TamaraFinanceContext";
import { useAbandonmentTracking } from "@/common/Contexts/AbandonmentTrackingContext";
import { trackEvents } from "@/common/events/events";
import useCookieClient from "@hooks/useCookieClient";
import OrderPaidMessage from "@/pages/checkout/CheckoutV2/components/OrderPaidMessage/OrderPaidMessage";
import ReservedMessage from "@/pages/checkout/CheckoutV2/components/ReservedMessage/ReservedMessage";
import Loader from "@componentsShared/Loader/Loader";
import { toast } from "sonner";
import HeadingSteps from "@/pages/checkout/shop-apply/shopApplyForm/HeadingSteps/HeadingSteps";
import BNPLMobileFormHeader from "@/pages/checkout/bnpl/common/components/BNPLMobileFormHeader";
import WarrantySection from "@/pages/checkout/warranty/WarrantySection";
var TamaraFinanceScreen = function TamaraFinanceScreen() {
  var _checkoutOrderV2$g4_d, _checkoutOrderV2$post;
  if (__IS_SSR__) return null;
  var lang = useLang();
  useWebviewInputFieldFocusBehavior(110);
  var _useTamaraFinance$sta = useTamaraFinance().state,
    userInfo = _useTamaraFinance$sta.userInfo,
    orderData = _useTamaraFinance$sta.orderData;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var _useState = useState(true),
    loader = _useState[0],
    setLoader = _useState[1];
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var _useTamaraFinance$que = useTamaraFinance().queryParams,
    post_id = _useTamaraFinance$que.post_id,
    financestep = _useTamaraFinance$que.financestep;
  var fetch__getOrderDetailsByParamsV2 = useTamaraFinance().remote_actions.fetch__getOrderDetailsByParamsV2;
  var _useState2 = useState(financestep === 2 && !isLoggedIn),
    isOtpStep = _useState2[0],
    setIsOtpStep = _useState2[1];
  var _useState3 = useState(false),
    autosend = _useState3[0],
    setAutoSend = _useState3[1];
  var _useState4 = useState(false),
    reachUpload = _useState4[0],
    setReachUpload = _useState4[1];
  var _useState5 = useState(false),
    ShowPopUp = _useState5[0],
    setShowPopUp = _useState5[1];
  var _useState6 = useState(null),
    checkoutOrderError = _useState6[0],
    setCheckoutOrderError = _useState6[1];
  var grantedPopup = useBoolean();
  var isDesktop = !isMobile;
  var _useTamaraFinance$sta2 = useTamaraFinance().state,
    checkoutOrderV2 = _useTamaraFinance$sta2.checkoutOrderV2,
    fetch_loading = _useTamaraFinance$sta2.fetch_loading;
  var initialCityId = useRef(userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id);
  var previousCityId = useRef(userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id);
  var _useAbandonmentTracki = useAbandonmentTracking(),
    startAbandonmentTracking = _useAbandonmentTracki.startAbandonmentTracking,
    completeAbandonmentTracking = _useAbandonmentTracki.completeAbandonmentTracking;
  var _useState7 = useState(false),
    hasUserStartedCheckoutForm = _useState7[0],
    setHasUserStartedCheckoutForm = _useState7[1];
  var g4DataLayer = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d === void 0 ? void 0 : _checkoutOrderV2$g4_d.g4_data_layer;
  var isWebView = useIsWebView();
  var webview = useWebview();
  useEffect(function () {
    webview.showTitleBar(false)["catch"](function () {});
  }, [isWebView]);
  useEffect(function () {
    if (!post_id || !g4DataLayer) return;
    if (hasUserStartedCheckoutForm) return;
    startAbandonmentTracking({
      key: "add_to_cart_completed_tamara_".concat(post_id),
      event: "add_to_cart_abandoned",
      shouldTrack: true,
      payload: _objectSpread(_objectSpread({}, g4DataLayer), {}, {
        inventory_type: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.inventory_type_string,
        post_trim: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_ext,
        booking_type: "tamara"
      })
    });
  }, [g4DataLayer, hasUserStartedCheckoutForm, post_id, startAbandonmentTracking, user === null || user === void 0 ? void 0 : user.id]);
  useEffect(function () {
    if (!post_id || !g4DataLayer || !hasUserStartedCheckoutForm) return;
    completeAbandonmentTracking("add_to_cart_completed_tamara_".concat(post_id));
    startAbandonmentTracking({
      key: "start_checkout_abandoned_tamara_".concat(post_id),
      event: "start_checkout_abandoned",
      shouldTrack: true,
      payload: _objectSpread(_objectSpread({}, g4DataLayer), {}, {
        inventory_type: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.inventory_type_string,
        post_trim: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_ext,
        booking_type: "tamara",
        last_completed_step: ""
      })
    });
  }, [g4DataLayer, completeAbandonmentTracking, hasUserStartedCheckoutForm, post_id, startAbandonmentTracking, user === null || user === void 0 ? void 0 : user.id]);
  var completeTamaraCheckoutAbandonmentTracking = function completeTamaraCheckoutAbandonmentTracking() {
    completeAbandonmentTracking("add_to_cart_completed_tamara_".concat(post_id));
    completeAbandonmentTracking("start_checkout_abandoned_tamara_".concat(post_id));
  };
  useEffect(function () {
    if (userInfo !== null && userInfo !== void 0 && userInfo.city_id && previousCityId.current !== undefined && previousCityId.current !== (userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id) && previousCityId.current !== "" &&
    // Skip if previous was empty (initialization, not user selection)
    String(initialCityId.current) !== String(userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id)) {
      var _checkoutOrderV2$sect, _checkoutOrderV2$sect2, _checkoutOrderV2$sect3, _checkoutOrderV2$sect4, _checkoutOrderV2$sect5;
      // Preserve selected warranty across city re-fetch
      var currentWarrantyId = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$sect = checkoutOrderV2.sections) === null || _checkoutOrderV2$sect === void 0 ? void 0 : (_checkoutOrderV2$sect2 = _checkoutOrderV2$sect.find(function (section) {
        return section.type === "warranty_list";
      })) === null || _checkoutOrderV2$sect2 === void 0 ? void 0 : (_checkoutOrderV2$sect3 = _checkoutOrderV2$sect2.items) === null || _checkoutOrderV2$sect3 === void 0 ? void 0 : (_checkoutOrderV2$sect4 = _checkoutOrderV2$sect3[0]) === null || _checkoutOrderV2$sect4 === void 0 ? void 0 : (_checkoutOrderV2$sect5 = _checkoutOrderV2$sect4.selected) === null || _checkoutOrderV2$sect5 === void 0 ? void 0 : _checkoutOrderV2$sect5.id;
      fetch__getOrderDetailsByParamsV2(_objectSpread({
        city_id: String(userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id)
      }, currentWarrantyId != null && {
        warranty_id: currentWarrantyId
      })).then(function (res) {
        if (res) {
          var msg = t("shipping_cost_updated", {
            ns: "web_checkout_cash"
          });
          toast.success(msg, {
            position: "bottom-center",
            duration: 2000,
            style: {
              zIndex: 9999999
            }
          });
        }
      });
    }
    previousCityId.current = userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id;
  }, [userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id]);
  var renderOTPStep = function renderOTPStep() {
    var verifyOtpCb = function verifyOtpCb(userData) {
      if (!isLoggedIn) {
        handleHasAccountEvent({
          hasAccount: userData.has_account,
          status: "Success",
          phone_number: userData === null || userData === void 0 ? void 0 : userData.phone_number,
          lang: lang,
          referral_location: "tamara_order"
        });
      }

      // After OTP verification, proceed with Tamara checkout
      // The TamaraInfoComponent will automatically call the API since user is now logged in
      setIsOtpStep(false);
      setAutoSend(true);
    };
    return /*#__PURE__*/React.createElement(OtpVerification, {
      FIX_ME__extra_params: {
        is_finance: true
      },
      source: "finance_order_verify",
      after_verify_callback: verifyOtpCb,
      scenario: "signup",
      phone_number: userInfo.mobile_number,
      onEditNumber: function onEditNumber() {
        navigateToHard("/finance-apply-tamara", {
          post_id: post_id,
          financestep: 1
        });
      },
      design: {
        btnText: tShort("phone_number_verification", {
          "ns": "otp_screen"
        }),
        className: stl.otpWrapper,
        subClassName: stl.fontSize,
        label: tShort("enter_code_sent_to", {
          "ns": "otp_screen"
        }),
        otpBtn: stl.otpBtn,
        withborder: false
      }
    });
  };
  var renderStepContent = function renderStepContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "mx-auto !w-[80%] max-w-[1152px] max-lg:!w-[90%] after:content-[''] after:fixed after:bottom-0 after:left-0 after:w-full after:h-full after:z-[-1] after:bg-[#ffffff] sm:after:bg-[#fafcff] !mt-0 md:!mt-8"
    }, !isMobile && financestep != 5 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      id: "checkout-cancel-btn",
      className: ["whtBtn", stl.backBtn].join(" "),
      onClick: function onClick() {
        return setShowPopUp(true);
      }
    }, t("cancel", {
      ns: "web_checkout_finance"
    }))), /*#__PURE__*/React.createElement("div", {
      className: twMerge("flex flex-col-reverse sm:flex-row items-start justify-between pb-10 mt-0", !isMobile && "gap-[22px] md:!mt-4")
    }, /*#__PURE__*/React.createElement("div", {
      className: twMerge("w-full relative sm:bg-white sm:min-w-[660px] sm:max-w-[660px] md:mx-auto", !isMobile && "border-none sm:rounded-xl sm:border sm:border-solid sm:border-[#EBF0F7] py-4 px-6")
    }, /*#__PURE__*/React.createElement(HeadingSteps, {
      className: isMobile && "pb-8"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: "14px",
        paddingBottom: "4px"
      },
      className: isOtpStep ? "completed" : "active"
    }, t("add_information", {
      ns: "web_checkout_cash"
    })), !isLoggedIn && /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: "14px",
        paddingBottom: "4px"
      },
      className: isOtpStep ? "active" : ""
    }, t("verify_code", {
      ns: "web_sell_trade"
    }))), isMobile && !isOtpStep && /*#__PURE__*/React.createElement(MobileCarInfoV2, {
      className: "mt-5 mb-6",
      checkoutOrderV2: checkoutOrderV2,
      onClickInfoIcon: grantedPopup.setTrue,
      hideData: true
    }), isMobile && !isOtpStep && /*#__PURE__*/React.createElement("div", {
      className: "mt-5"
    }, /*#__PURE__*/React.createElement(WarrantySection, {
      checkoutOrderV2: checkoutOrderV2,
      orderType: "tamara",
      referralLocation: "checkout",
      onWarrantyChange: function onWarrantyChange(id) {
        return void fetch__getOrderDetailsByParamsV2({
          warranty_id: id,
          city_id: String((userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id) || "")
        });
      }
    })), isOtpStep ? renderOTPStep() : financestep === 1 && /*#__PURE__*/React.createElement(TamaraInfoComponent, {
      autosend: autosend,
      setIsOtpStep: setIsOtpStep,
      onFormUpdated: setHasUserStartedCheckoutForm,
      onFormCompleted: completeTamaraCheckoutAbandonmentTracking
    })), /*#__PURE__*/React.createElement("div", {
      id: "checkout-payment-container",
      className: "w-full sm:min-w-[444px] sm:max-w-[444px]"
    }, isDesktop && /*#__PURE__*/React.createElement(PaymentInfoV2, {
      loading: fetch_loading || !checkoutOrderV2,
      checkoutOrderV2: checkoutOrderV2,
      className: "border-none md:rounded-xl md:border md:border-solid md:border-[#EBF0F7]",
      hideData: true,
      onClickInfoIcon: grantedPopup.setTrue,
      orderType: "tamara",
      showWarrantyWidget: isDesktop && !isOtpStep,
      onWarrantySelected: function onWarrantySelected(id) {
        return void fetch__getOrderDetailsByParamsV2({
          warranty_id: id,
          city_id: String((userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id) || "")
        });
      }
    }))));
  };

  // Handle loading state
  if (fetch_loading) {
    return /*#__PURE__*/React.createElement(Layout, {
      hideHeaderOnmobile: true,
      disableLoader: true,
      hideFooterWithoutAuthMsg: true,
      authenticationMsg: true,
      hideAppBanner: true,
      linksForSearch: true,
      mainClass: "AribFinancePage",
      headHideLinks: true,
      hideOrangeHeadBtn: true
    }, /*#__PURE__*/React.createElement(Loader, null));
  }

  // Handle error states - check for OrderPaidError and PostReservedError
  if (checkoutOrderError) {
    if (checkoutOrderError instanceof OrderPaidError) {
      return /*#__PURE__*/React.createElement(Layout, {
        hideHeaderOnmobile: true,
        disableLoader: true,
        hideFooterWithoutAuthMsg: true,
        authenticationMsg: true,
        hideAppBanner: true,
        linksForSearch: true,
        mainClass: "AribFinancePage",
        headHideLinks: true,
        hideOrangeHeadBtn: true
      }, /*#__PURE__*/React.createElement(OrderPaidMessage, {
        order_id: (orderData === null || orderData === void 0 ? void 0 : orderData.order_id) || ''
      }));
    } else if (checkoutOrderError instanceof PostReservedError) {
      return /*#__PURE__*/React.createElement(Layout, {
        hideHeaderOnmobile: true,
        disableLoader: true,
        hideFooterWithoutAuthMsg: true,
        authenticationMsg: true,
        hideAppBanner: true,
        linksForSearch: true,
        mainClass: "AribFinancePage",
        headHideLinks: true,
        hideOrangeHeadBtn: true
      }, /*#__PURE__*/React.createElement(ReservedMessage, null));
    }
  }
  return /*#__PURE__*/React.createElement(Layout, {
    hideHeaderOnmobile: true,
    custommobileHeader: !reachUpload && isMobile && /*#__PURE__*/React.createElement(BNPLMobileFormHeader, {
      hideBack: isOtpStep,
      updateShowPopUp: setShowPopUp,
      title: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post = checkoutOrderV2.post) === null || _checkoutOrderV2$post === void 0 ? void 0 : _checkoutOrderV2$post.post_title
    }),
    disableLoader: true,
    hideFooterWithoutAuthMsg: true,
    authenticationMsg: true,
    hideAppBanner: true,
    linksForSearch: true,
    mainClass: "AribFinancePage",
    headHideLinks: true,
    hideOrangeHeadBtn: true
  }, renderStepContent(), ShowPopUp && /*#__PURE__*/React.createElement(SharedPopUp, {
    show: ShowPopUp,
    onClose: function onClose() {
      return setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.freeFinanceCancelOreder
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.freeFinanceCancelIcon
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-center"
  }, t("sure_cancel_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center"
  }, t("information_saved_need_refill_data", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "blueBtn",
    onClick: function onClick() {
      setShowPopUp(false);
    }
  }, t("continue_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "whtBtn",
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            trackEvents(hasUserStartedCheckoutForm ? "start_checkout_abandoned" : "add_to_cart_abandoned", _objectSpread(_objectSpread({}, g4DataLayer || {}), {}, {
              inventory_type: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.inventory_type_string,
              post_trim: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_ext,
              booking_type: "tamara"
            }));
            completeTamaraCheckoutAbandonmentTracking();
            if (orderData !== null && orderData !== void 0 && orderData.order_uuid) {
              setShowPopUp(false);
              setLoader(true);
            }
            navigateTo("/cardetail/".concat(post_id));
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))
  }, t("cancel_submitting_application", {
    ns: "web_tracking"
  })))));
};
export default TamaraFinanceScreen;